import * as yup from "yup";
import {
  decimalStringTest,
  emailFieldvalidation,
  exactLengthIfPresent,
  isNotFutureDateTest,
  isValidDateTest,
  maxLengthMessage,
} from "../../../utils/functions";
import { RegularExpressions } from "../../../utils/regular-expressions";

const employeeSchema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .matches(RegularExpressions.Name, "Invalid First Name")
    .required("First Name is required")
    .max(100, maxLengthMessage(100)),
  lastName: yup
    .string()
    .trim()
    .matches(RegularExpressions.Name, "Invalid Last Name")
    .required("Last Name is required")
    .max(100, maxLengthMessage(100)),
  middleName: yup.string().trim().matches(RegularExpressions.Name, "Invalid Middle Name").max(50, maxLengthMessage(50)),
  suffix: yup.string().trim().max(100, maxLengthMessage(100)),
  dob: isValidDateTest("Date of Birth").concat(
    isNotFutureDateTest("Date of Birth")
  ),
  ssn: yup
    .string()
    .trim()
    .test(
      "ssn-length",
      "SSN should be of 9 digits",
      (value) => !value || value.length === 9
    ),
  email: emailFieldvalidation,
  gender: yup.string().nullable(),
  race: yup.string().nullable(),
  status: yup.string().nullable(),
  employeeNum: yup
    .string()
    .trim()
    .matches(RegularExpressions.ID, "Invalid Employee ID")
    .max(100, maxLengthMessage(100))
    .nullable(),
  phoneNo: yup
    .string()
    .nullable()
    .matches(/^\d*$/, "Must be digits only")
    .max(200, maxLengthMessage(200, "digits")),
  cellNo: yup
    .string()
    .nullable()
    .matches(/^\d*$/, "Must be digits only")
    .max(25, maxLengthMessage(25, "digits")),
  pagerNo: yup
    .string()
    .nullable()
    .matches(/^\d*$/, "Must be digits only")
    .max(25, maxLengthMessage(25, "digits")),
  dl: yup.string().trim().matches(RegularExpressions.ID, "Invalid Driver's Lic#").max(45, maxLengthMessage(45)).nullable(),
  dlState: yup.string().nullable(),
  dlExpire: isValidDateTest("DL Expiration Date"),
  workPhoneNum: yup.string().trim().max(200, maxLengthMessage(200)).nullable(),
  address: yup.string().trim().max(250, maxLengthMessage(250)).nullable(),
  rCity: yup.string().max(100, maxLengthMessage(100)).nullable(),
  rState: yup.string().nullable(),
  rZip: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  mAddress: yup.string().trim().max(250, maxLengthMessage(250)).nullable(),
  mCity: yup.string().max(100, maxLengthMessage(100)).nullable(),
  mState: yup.string().trim().nullable(),
  mZip: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  maritalStatus: yup.string().nullable(),
  spouseName: yup.string().trim().matches(RegularExpressions.Name, "Invalid Spouse Name").max(50, maxLengthMessage(50)).nullable(),
  spousePhoneNumber: yup
    .string()
    .trim()
    .max(200, maxLengthMessage(200))
    .nullable(),
  spouseSSN: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  spouseEmployer: yup.string().trim().matches(RegularExpressions.Name, "Invalid Spouse Employer").max(50, maxLengthMessage(50)).nullable(),
  emergencyContact: yup
    .string()
    .trim()
    .max(25, maxLengthMessage(25))
    .nullable(),
  relationship: yup.string().nullable(),
  ecHomePhone: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  ecCellNo: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  contactCity: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  contactAddress: yup
    .string()
    .trim()
    .max(200, maxLengthMessage(200))
    .nullable(),
  contactState: yup.string().nullable(),
  contactZip: yup.string().trim().max(25, maxLengthMessage(25)).nullable(),
  bloodType: yup.string().nullable(),
  medicalNotes: yup
    .string()
    .trim()
    .max(1000, maxLengthMessage(1000))
    .nullable(),
  positionNum: exactLengthIfPresent("Position #", 10),
  masterCostCenter: exactLengthIfPresent("Master Cost Center", 10),
  salary: decimalStringTest("Salary", 15, 2),
  annualSalary: decimalStringTest("Annual Salary", 15, 2),
  titlePosition: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  rank: yup.string().trim().max(20, maxLengthMessage(20)).nullable(),
  classCode: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  grade: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  personnelNum: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  personnelArea: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  subArea: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  orgUnit: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  contract: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  positionStartDate: isValidDateTest("Position Start Date"),
  positionEndDate: isValidDateTest("Position End Date"),
  dateLwopMilitary: isValidDateTest("LWOP Military Date"),
  dateReturnedPayroll: isValidDateTest("Returned PayrollDate"),
  perfRevDate: isValidDateTest("Perf. Review Date"),
  careerServiceDate: isValidDateTest("Career Service Date"),
  leaveAccDate: isValidDateTest("Leave Accrual Date"),
  careerServicePayment: decimalStringTest("Carrer Service Payment", 15, 2),
  orderNum: yup.string().trim().matches(RegularExpressions.ID, "Invalid Order#").max(50, maxLengthMessage(50)).nullable(),
  percentage: decimalStringTest("Percentage", 2, 2),
  internalCC: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  wbsElement: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  wbscc: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  otherCC: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  orgChart: yup.boolean().nullable(),
  flsaStatus: yup.string().oneOf(["Exempt", "Non Exempt", null]).nullable(),
  cgdg: yup.boolean().nullable(),
  clip: yup.boolean().nullable(),
  commissionedDate: isValidDateTest("Commission Date"),
  trooperDate: isValidDateTest("Effective Date"),
  latestHireDate: isValidDateTest("Latest Hire Date"),
  hireDate: isValidDateTest("Hire Date"),
  badgeNum: yup.string().trim().matches(RegularExpressions.ID, "Invalid Badge/Rep#").max(50, maxLengthMessage(50)).nullable(),
  department: yup.string().trim().max(30, maxLengthMessage(30)).nullable(),
  departmentDate: isValidDateTest("Department/Division Date"),
  section: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  sectionDate: isValidDateTest("Section Date"),
  residentialCounty: yup
    .string()
    .trim()
    .max(50, maxLengthMessage(50))
    .nullable(),
  assignedCounty: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  education: yup.string().trim().max(65, maxLengthMessage(65)).nullable(),
  notes: yup.string().nullable(),
  militaryNotes: yup.string().trim().max(250, maxLengthMessage(250)).nullable(),
  dropDate: isValidDateTest("Drop Date"),
  retireDate: isValidDateTest("Retire Date"),
  separationDate: isValidDateTest("Term Date"),
  separationCode: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  separationComments: yup.string().max(500, maxLengthMessage(500)).nullable(),
  rehire: yup
    .string()
    .oneOf(["OK to rehire", "Do not rehire", null])
    .nullable(),
});

export default employeeSchema;
